module.exports = __webpack_public_path__ + "images/category_lp/pc/PC3_a9e0a4b9ee4987a953ad43670ff194ee.png";